import React from "react";
import ResponsiveImage from "./ResponsiveImage.js";

// import LazyLoad from "react-lazyload";
// <IsLazy></IsLazy>
// const IsLazy = ({ lazy = false, children }) => {
//   if (lazy) {
//     return (
//       <LazyLoad placeholder={<ResponsiveImage />} debounce={100} offset={1000}>
//         {children}
//       </LazyLoad>
//     );
//   } else {
//     return <>{children}</>;
//   }
// };

const ProgressiveLoader = ({
  image = "https://placekitten.com/600/400",
  loadWidth = 100,
  finalWidth = 400,
  loadQuality = 40,
  finalQuality = 90,
  children,
}) => {
  // const placeholderUrl = `${image}?w=${loadWidth}&q=${loadQuality}`;
  // const imageUrl = `${image}?w=${finalWidth}&q=${finalQuality}`;

  // const runOnce = true;
  // const [loadState, setLoadState] = useState({
  //   src: placeholderUrl,
  //   loaded: false,
  // });

  // useEffect(() => {
  //   const img = new Image();

  //   img.onload = () => {
  //     setLoadState({
  //       src: img.src,
  //       loaded: true,
  //     });
  //   };

  //   img.src = imageUrl;
  // }, [runOnce]);
  const imageUrl = `${image}?w=${finalWidth}&q=${finalQuality}`;

  return (
    <ResponsiveImage image={imageUrl} loaded={true}>
      {children && children}
    </ResponsiveImage>
  );
};

export default ProgressiveLoader;
